import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CurrencyPipe } from '../../shared/pipes/currency.pipe';
import { CategoryModel, EntryModel } from '../finance.model';

export interface EntryDialogData {
  title: string,
  entry: Partial<EntryModel>,
  categories: CategoryModel[]
}

@Component({
  selector: 'finance-entry-dialog',
  standalone: false,
  template: `
    <form #form="ngForm" (ngSubmit)="save(form.value)">
      <h2 mat-dialog-title>{{ entry.id ? 'Modify' : 'Create' }} {{ data.title }}</h2>
      <mat-dialog-content>
        <mat-form-field>
          <mat-label>Description</mat-label>
          <input matInput [(ngModel)]="entry.description" name="description" required>
        </mat-form-field>
        &nbsp;&nbsp;
        <mat-form-field>
          <mat-label>Category</mat-label>
          <mat-select [(ngModel)]="entry.category" name="category">
            <mat-option value="">—</mat-option>
            <mat-option *ngFor="let c of data.categories" [value]="c.name">{{ c.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-divider></mat-divider>
        <mat-form-field>
          <mat-label>Value</mat-label>
          <input matInput type="text" currency [ngModel]="entry.value | number:'1.2-2' | currency" name="value" placeholder="0,00" required>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button type="submit" [disabled]="form.invalid">Save</button>
        <button mat-raised-button type="button" mat-dialog-close>Cancel</button>
      </mat-dialog-actions>
    </form>
  `
})
export class EntryDialogComponent {
  entry: Partial<EntryModel>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EntryDialogData,
    private dialogRef: MatDialogRef<EntryDialogComponent>,
    private currencyPipe: CurrencyPipe
  ) {
    this.entry = { description: '', category: '', value: 0, ...data.entry };
  }

  save(values: any): void {
    this.dialogRef.close({
      ...this.entry,
      description: (this.entry.description ?? '').trim(),
      category: this.entry.category ?? '',
      value: parseFloat(this.currencyPipe.transform(values['value'], false))
    });
  }
}
